import { Component, OnInit, Inject, OnDestroy, Output, EventEmitter } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { filter, firstValueFrom, Subject, takeUntil } from 'rxjs';
import { protectedResources } from './auth-config';
import { WaitingService } from './services/waiting.service';
import { DefaultValuesService } from './services/defaultvalues.service';
import { ComponentTool } from './interfaces/componenttool';
import { NavigationEnd, Router } from '@angular/router';
import { DialogService } from './services/dialog.service';
import { Utils } from './utils/utils';
import { HttpClient } from '@angular/common/http';
import { AppModuleComponent } from './interfaces/appmodules';
import { log } from 'console';
import { CookieDisclaimerService } from './services/cookie-disclaimer.service';
import { CookieDisclaimerComponent } from './components/cookiedisclaimer/cookie-disclaimer.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../environments/environment';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css', 'style/tke-theme.less', 'style/new-generic-styles.component.less', 'style/menu.component.less'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    @Output() onTenantChanged = new EventEmitter<string>();
    @Output() onControllerTypeChanged = new EventEmitter<ControllerType>();
    @Output() onLanguageChanged = new EventEmitter<Language>();
    @Output() onStageChanged = new EventEmitter<string>();
    @Output() onManagementIdChanged = new EventEmitter<string>();
    componentToolEnum: typeof ComponentTool = ComponentTool;

    private readonly _destroying$ = new Subject<void>();
    hideControllerTypeMenuItem = true;
    hideLanguageMenuItem = true;
    hideContractMenuItem = true;
    hideTenantMenuItem = true;
    hideGroupFunctionMenuItem = true;
    hideManagementIdMenuItem = true;
    hideFiscalYearMenuItem = true;
    hidePeriodMenuItem = true;
    hideOwnerMenuItem = true;
    hideOplVersionMenuItem = true;
    hideInlineDoc = true;
    hideCountryMenuItem = true;
    hidePopulationMenuItem = true;
    hideRegulatoryAndDialerItem = true;
    hideWaveItem = true;
    hideQuarterItem = true;


    isWikiBtnDisabled = true;
    currentUser: string = '';
    isControllerOwner: any;
    isDigitalServiceView: any = false;
    reload = 0;
    selectedItem = 1;
    currentYear = 0;

    showWikiLoadBar = false;
    currentLocation = '';
    authServiceInitilized = false;

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        public authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        public waiting: WaitingService,
        public dialog: DialogService,
        public defaults: DefaultValuesService,
        public router: Router,
        private http: HttpClient,
        public cookieDisclaimerService: CookieDisclaimerService,
        public matDialog: MatDialog,
        @Inject('BASE_URL') private baseUrl: string
    ) {
        if (window.location.href.toLowerCase().includes('rulebook')) {
            this.currentLocation = 'Rulebook'
        }
        else if (window.location.href.toLowerCase().includes('mersy')) {
            this.currentLocation = 'Mersy'
        }
        else {
        }
    }
    isAuthenticated = true;

    async ngOnInit(): Promise<void> {
        // Get current year
        this.currentYear = new Date().getFullYear();

        if (this.authService.instance.getAllAccounts().length) {
            // User is already authenticated
            await this.setLoginDisplay();
        } else {
            // Wait for authentication to finish
            this.msalBroadcastService.inProgress$
                .pipe(
                    filter((status: InteractionStatus) => status === InteractionStatus.None),
                    takeUntil(this._destroying$)
                )
                .subscribe(() => {
                    this.setLoginDisplay();
                });
        }

        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.reload = Math.random() * 100
                if (event.url === '/contract' || event.url === '/customer' || event.url === '/assets' || event.url === '/chairlift' || event.url === '/inspection' || event.url === '/contacttounit'
                    || event.url === '/service-ticket' || event.url === '/file/2' || event.url === '/file/3' || event.url === '/file/34' || event.url === '/file/35'
                    || event.url === '/file/4' || event.url === '/file/5' || event.url === '/file/7' || event.url === '/file/8' || event.url === '/file/9' || event.url === '/file/36'
                    || event.url === '/backend-setup' || event.url === '/file/10' || event.url === '/file/11'
                    || event.url === '/kpi' || event.url === '/file/12' || event.url === '/servicesdatacheck' || event.url === '/nonrecoverableerrors'
                    || event.url === '/virtualprovisioning' || event.url === '/file/14' || event.url === '/file/34'
                    || event.url === '/customer-document' || event.url === '/file/33' || event.url === '/contacts') {
                    this.hideQuarterItem = this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideControllerTypeMenuItem = this.hideLanguageMenuItem = this.hideOwnerMenuItem =
                        this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = true;
                    this.hideContractMenuItem = this.hideTenantMenuItem = this.isDigitalServiceView = false
                }
                else if (event.url === '/' || event.url === '/home' || event.url === '/maintenancecontrolplan' || event.url.includes('/maintenancecontrolplangroup/')) {
                    if (event.url === '/')
                        this.selectedItem = -1;
                    if (event.url === '/home')
                        this.router.navigate(['/']); // navigate to home page.
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideLanguageMenuItem = this.hideContractMenuItem = this.hideOwnerMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                    this.isDigitalServiceView = false
                }
                else if (event.url === '/harmonizedopmodes' || event.url === '/businesskey') {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideControllerTypeMenuItem = this.hideContractMenuItem = this.hideOwnerMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                    this.hideTenantMenuItem = this.hideLanguageMenuItem = this.isDigitalServiceView = false
                }
                else if (event.url === '/globaltasklist') {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideContractMenuItem = this.hideOwnerMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                    this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.isDigitalServiceView = false
                }
                else if (event.url === '/deploymentsdevops') {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideControllerTypeMenuItem = this.hideTenantMenuItem = this.hideContractMenuItem = this.hideOwnerMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                    this.hideLanguageMenuItem = false;
                }
                else if (event.url === '/keyvaultmanagement') {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideControllerTypeMenuItem = this.hideTenantMenuItem = this.hideContractMenuItem = this.hideOwnerMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                    this.hideLanguageMenuItem = true;
                }
                else if (event.url === '/digitalservices' || event.url === '/file/13') {
                    this.hideControllerTypeMenuItem = this.hideLanguageMenuItem = this.hideTenantMenuItem = this.hideOwnerMenuItem = false;
                    this.hideWaveItem = this.hideCountryMenuItem = this.hideContractMenuItem = this.isDigitalServiceView = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hidePopulationMenuItem = this.hideQuarterItem = true;
                }
                else if (event.url === '/file/0' || event.url === '/file/1' || event.url === '/fingerprint-rules') {
                    this.isDigitalServiceView = undefined
                    this.hideControllerTypeMenuItem = this.hideLanguageMenuItem = this.hideTenantMenuItem = this.hideOwnerMenuItem = false;
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideContractMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                }
                else if (event.url === '/testcases') {
                    this.isDigitalServiceView = undefined
                    this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = false
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideLanguageMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                }
                else if (event.url === '/controllertypes-deploymentstatus' || event.url === '/healthscore') {
                    event.url === '/healthscore' ? this.hidePopulationMenuItem = false : this.hidePopulationMenuItem = true;
                    this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = false
                    this.hideWaveItem = this.hideCountryMenuItem = this.hideLanguageMenuItem = this.hideContractMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                }
                else if (event.url === '/remoteactions') {
                    this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideLanguageMenuItem = false
                    this.hideWaveItem = this.hideCountryMenuItem = this.hideContractMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hidePopulationMenuItem = this.hideQuarterItem = true
                }
                else if (event.url === '/ControllerTypeHarmonization' || event.url === '/backendharmonization' || event.url === '/branch-hierarchy' || event.url === '/file/6') {
                    this.hideTenantMenuItem = false
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem =
                        this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                }

                else if (event.url === '/changelog') {
                    this.hideControllerTypeMenuItem = false
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem =
                        this.hideLanguageMenuItem = this.hideTenantMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                }
                else if (event.url.includes('/actualreporting') || event.url.includes('/actualbranchreporting') || event.url.includes('/niops') || event.url.includes('/file/27') || event.url === '/file/15' || event.url === '/file/18') {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                    this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = false;
                }
                else if (event.url === '/file/16' || event.url === '/file/17' || event.url === '/file/19' || event.url === '/file/20' || event.url.includes('/oplkpi')) {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                    this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = false;
                }
                else if (event.url === '/market-sheet' || event.url === '/segment-sheet' || event.url === '/file/21' || event.url === '/file/22') {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = this.hideOplVersionMenuItem = this.hideQuarterItem = true
                    this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hideFiscalYearMenuItem = false;
                }
                else if (event.url === '/monitoringdevops' || event.url.includes('/sectionscheduler') || event.url.includes('/adminsection')) {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideWaveItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                }
                else if (['/branch-excellence-admin', '/file/28', '/file/29'].includes(event.url)) {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideQuarterItem = true
                    this.hideManagementIdMenuItem = this.hideLanguageMenuItem = true
                }
                else if (event.url === '/assessment') {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideOplVersionMenuItem = this.hideQuarterItem = this.hideFiscalYearMenuItem = true
                    this.hideLanguageMenuItem = this.hideWaveItem = this.hideManagementIdMenuItem = false
                }
                else if (event.url === '/focus-plan' || event.url === '/file/30' || event.url === '/file/' + Utils.getFileUploadFocusPlanDefinition() || event.url === '/file/' + Utils.getFileUploadFocusPlanFinancialImpact()) {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideOplVersionMenuItem = this.hideLanguageMenuItem = this.hideQuarterItem = true
                    this.hideManagementIdMenuItem = this.hideWaveItem = this.hideFiscalYearMenuItem = false
                }
                else if (event.url.includes('/hierarchysetup')) {
                    this.hideWaveItem = this.hideRegulatoryAndDialerItem = this.hidePopulationMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                    this.hideCountryMenuItem = false;
                }
                else if (event.url === '/UmpHome' || event.url.includes('/EditUser') || event.url.includes('/UMPAnalytics') || event.url.includes('/UmpGroups')) {
                    this.hideWaveItem = this.hideRegulatoryAndDialerItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem =
                        this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                    this.hideContractMenuItem = false;
                }
                else if (event.url === '/tenantdialerconfig') {
                    this.hideContractMenuItem = this.hideRegulatoryAndDialerItem = this.hideTenantMenuItem = false
                    this.hideWaveItem = this.hideCountryMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem =
                        this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hidePopulationMenuItem = this.hideQuarterItem = true
                }
                else if (event.url === '/field-settings') {
                    this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideCountryMenuItem =
                        this.hidePopulationMenuItem = this.hideFiscalYearMenuItem = this.hideGroupFunctionMenuItem =
                        this.hideOplVersionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                    this.hideContractMenuItem = false;
                    this.setStageFromEnv();
                }
                else if (event.url === '/contractvalidation') {
                    this.hideContractMenuItem = this.hideTenantMenuItem = false;
                    this.hideControllerTypeMenuItem = this.hideLanguageMenuItem = this.hideCountryMenuItem =
                        this.hidePopulationMenuItem = this.hideFiscalYearMenuItem = this.hideGroupFunctionMenuItem =
                        this.hideOplVersionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = 
                        this.hideRegulatoryAndDialerItem = this.hideQuarterItem = this.hideWaveItem = this.hideOwnerMenuItem = true;
                }
                else if (['/software-releases', '/manufacturing-settings'].includes(event.url)) {
                    this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideCountryMenuItem =
                        this.hidePopulationMenuItem = this.hideFiscalYearMenuItem = this.hideGroupFunctionMenuItem =
                        this.hideOplVersionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                    this.hideContractMenuItem = false;
                    this.setStageFromEnv();
                }
                else if (['/marketquery-report', '/eoxniops-report', '/kpimersyreport'].includes(event.url)) {
                    this.hideContractMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideCountryMenuItem =
                        this.hidePopulationMenuItem = this.hideFiscalYearMenuItem = this.hideGroupFunctionMenuItem =
                        this.hideOplVersionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                }
                else if (['/pequarterreporting', '/file/37'].includes(event.url)) {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideLanguageMenuItem = this.hideWaveItem = this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideOplVersionMenuItem = true
                    this.hideManagementIdMenuItem = this.hideFiscalYearMenuItem = this.hideQuarterItem = false
                }
                else if (['/peyearlyplanning', '/file/38'].includes(event.url)) {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideLanguageMenuItem = this.hideWaveItem = this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideQuarterItem = true
                    this.hideManagementIdMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = false
                }
                else if (['/pe-configuration'].includes(event.url)) {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem =
                        this.hideOwnerMenuItem = this.hideContractMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem =
                        this.hideFiscalYearMenuItem = this.hidePeriodMenuItem = true
                    this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = false;
                }
                else if (event.url === '/dialerdefaultfirmware') {
                    this.hideContractMenuItem = false;
                    this.hideWaveItem = this.hideCountryMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideTenantMenuItem =
                        this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem =
                        this.hidePopulationMenuItem = this.hideQuarterItem = this.hideRegulatoryAndDialerItem = true;
                }
                else if (event.url === '/osh-admin') {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem =
                        this.hideManagementIdMenuItem = this.hideLanguageMenuItem = true
                }
                else if (event.url === '/osh-assessment') {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true
                    this.hideManagementIdMenuItem = false
                    this.hideLanguageMenuItem = false
                    this.hideWaveItem = false
                }                
                else if (event.url.includes('/inco-masterdata')) {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = this.hideOplVersionMenuItem = this.hideFiscalYearMenuItem = true
                    this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = false;
                }
                else if (['/inco-actualreporting', '/file/43'].includes(event.url)) {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideLanguageMenuItem = this.hideWaveItem = this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideOplVersionMenuItem = true
                    this.hideManagementIdMenuItem = this.hideFiscalYearMenuItem = this.hideQuarterItem = false
                }
                else if (['/inco-oplreporting', '/file/44'].includes(event.url)) {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                        this.hideLanguageMenuItem = this.hideWaveItem = this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideQuarterItem = true
                    this.hideManagementIdMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = false
                }
                else if (event.url.includes('/inco-focusprojects')) {
                    this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem =
                    this.hideLanguageMenuItem = this.hideWaveItem = this.hideGroupFunctionMenuItem = this.hidePeriodMenuItem = this.hideQuarterItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = true
                    this.hideManagementIdMenuItem = false;
                }
                else if (event.url.includes('/inco-validation')) {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem = this.hideContractMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = true
                    this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = true;
                    this.hideQuarterItem = this.hideOplVersionMenuItem = this.hideFiscalYearMenuItem = false;
                }
                else if (event.url.includes('/inco-admin')) {
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = 
                    this.hideOwnerMenuItem = this.hideContractMenuItem = this.hidePeriodMenuItem = this.hideRegulatoryAndDialerItem = this.hideGroupFunctionMenuItem = 
                    this.hideManagementIdMenuItem = this.hideQuarterItem = this.hideOplVersionMenuItem = this.hideFiscalYearMenuItem = true;
                }
                else if (event.url.includes('/kpiproducthierarchy')) {
                    this.hideWaveItem = this.hideRegulatoryAndDialerItem = this.hidePopulationMenuItem = this.hideLanguageMenuItem = this.hideControllerTypeMenuItem = this.hideOwnerMenuItem =
                        this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = this.hideCountryMenuItem = true;
                    this.hideTenantMenuItem = this.hideContractMenuItem = false;    
                }
                else if (['/usermngportal', '/branchexcellence', '/market-query', '/eoxniops', '/pe-reporting', '/osh', '/investment-controlling', '/kpimanagement'].includes(event.url)){
                    this.hideWaveItem = this.isDigitalServiceView = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideTenantMenuItem = this.hideControllerTypeMenuItem = this.hideLanguageMenuItem = this.hideContractMenuItem = this.hideOwnerMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = this.hideQuarterItem = true;
                }
                else {
                    this.hideControllerTypeMenuItem = this.hideLanguageMenuItem = this.hideTenantMenuItem = this.hideOwnerMenuItem = this.isDigitalServiceView = false;
                    this.hideWaveItem = this.hidePopulationMenuItem = this.hideCountryMenuItem = this.hideContractMenuItem = this.hideGroupFunctionMenuItem = this.hideManagementIdMenuItem = this.hidePeriodMenuItem = this.hideFiscalYearMenuItem = this.hideOplVersionMenuItem = this.hideRegulatoryAndDialerItem = true
                }
            }
        }
        )
    }

    private async setLoginDisplay(): Promise<void> {
        console.log('[call] setLoginDisplay()')
        const accounts = this.authService.instance.getAllAccounts();

        if (accounts.length === 0) {
            this.isAuthenticated = false;
            return;
        }

        // Set active account if not already set
        if (!this.authService.instance.getActiveAccount() && accounts.length > 0) {
            this.authService.instance.setActiveAccount(accounts[0]);
        }

        // Try to acquire token silently to validate if the token is still valid
        try {
            await firstValueFrom(this.authService.acquireTokenSilent({
                scopes: protectedResources.api.scopes.read,
                account: this.authService.instance.getActiveAccount() || accounts[0]
            }));

            this.isAuthenticated = true;
            this.authServiceInitilized = true;

            // Initialize the app only after successful authentication and only once
            if (this.isAuthenticated && !this.defaults.loadInitialData) {
                this.initializeApp();
            }
        } catch (error) {
            console.log('Token expired or invalid, user needs to log in again', error);
            this.isAuthenticated = false;
            this.authServiceInitilized = false;
        }
    }

    private initializeApp(): void {
        console.log('[call] initializeApp()')
        const tthis = this;

        Utils.getClusterComponent(this.http, this.baseUrl, this,
            function (tthis: AppComponent, res: AppModuleComponent) {
                tthis.defaults.isActualReportingEnabled = res.IsActualReportingEnabled
                tthis.defaults.isMonthlyOPLEnabled = res.IsMonthlyOplEnabled
                tthis.defaults.isYearlyOPLEnabled = res.IsYearlyOplEnabled
                tthis.defaults.isActualBranchReportingEnabled = res.IsActualBranchReportingEnabled
                tthis.defaults.isMonthlyOPLBranchReportingEnabled = res.IsMonthlyOplBranchReportingEnabled
                tthis.defaults.isYearlyOPLBranchReportingEnabled = res.IsYearlyOplBranchReportingEnabled

                tthis.defaults.setComponentTool(res.ComponentTool)
                tthis.defaults.menuClusters = res.Clusters
                tthis.defaults.components = [];
                let counter = 0;
                res.Clusters.forEach(x => {
                    x.ClusterId = counter;
                    if (x.ClusterComponents) {
                        x.ClusterComponents.forEach(y => {
                            tthis.defaults.components.push({ ...y, ClusterName: x.DisplayName, ClusterId: counter })
                        })
                    }
                    else {
                        tthis.defaults.components.push({ ...x, ClusterId: counter })
                    }
                    counter++;
                })

                const url = tthis.baseUrl + "api/generic/default/" + Utils.getDomainByWindowLocation();
                tthis.http.get<Defaults>(url)
                    .subscribe({
                        next: res => {
                            tthis.initializeUI(res);
                        },
                        error: error => Utils.writeLog(tthis.http, tthis.baseUrl, error)
                    });

                const cookie = tthis.cookieDisclaimerService.getCookie(tthis.defaults.componentTool);
                if (!cookie) {
                    const dialogRef = tthis.matDialog.open(CookieDisclaimerComponent, {
                        width: '600px',
                        disableClose: true,
                        position: { top: '5vh' }
                    });
                }
            }
        );
    }

    initializeUI(defaultsData: Defaults): void {
        this.currentUser = defaultsData.Session.UserUPN;
        this.isControllerOwner = defaultsData.IsControllerOwner;
        this.defaults.isControllerOwner = this.isControllerOwner;
        let tempTenants: Tenant[] = [];
        if (this.defaults.componentTool === this.componentToolEnum.Rulebook) {
            if (defaultsData.Claims === null) {
                // This is for the AD account scenario
                tempTenants.push({ Tenant: defaultsData.Session.Tenant, CountryName: 'Administrator', AllBranches: 0, Environment: 'AdministratorEnvironment' });
            }
            else {
                tempTenants.push(defaultsData.Claims.PrimaryTenants);
                for (const tenant of defaultsData.Claims.SecondaryTenants) {
                    tempTenants.push(tenant);
                }

            }
            tempTenants = tempTenants.sort(function (a, b) {
                if (a.Tenant < b.Tenant) { return -1; }
                if (a.Tenant > b.Tenant) { return 1; }
                return 0;
            })

            tempTenants.forEach(x => x.Label = `${x.CountryName} - (${x.Tenant})`)

            this.defaults.environments = defaultsData.Claims.Environments;

            if (this.defaults.environments.find(x => x.toUpperCase() === 'AMS')) {
                this.defaults.environments = this.defaults.environments.filter(x => x.toUpperCase() !== 'AMS');
                this.defaults.environments.push('NA');
                this.defaults.environments.push('LA');
            }

            tempTenants.forEach(x => x.Environment = x.Environment?.toUpperCase())
            this.defaults.tenants = tempTenants;
            this.defaults.tenant = defaultsData.Session.Tenant;
            this.defaults.controllertypes = defaultsData.ControllerTypesByTenant;
            this.defaults.controllertypesdigitalservices = defaultsData.ControllerTypesByTenantDigitalServices;
            this.defaults.controllertype = defaultsData.SelectedControllerType;
            this.defaults.languages = defaultsData.Languages;

            this.defaults.language = defaultsData.SelectedLanguage;
            this.defaults.isCountryBackendProdUser = defaultsData.IsCountryBackendProdUser;
            this.defaults.isDomainExpertUser = defaultsData.IsDomainExpertUser;
            this.defaults.isCountryBackendStableUser = defaultsData.IsCountryBackendStableUser;
            this.defaults.isReadonlyUser = defaultsData.IsReadonlyUser;
            this.defaults.isHomeUser = defaultsData.IsHomeUser;
            this.defaults.stage = defaultsData.Session.Stage;
            this.defaults.stageAfterRedirect = defaultsData.Session.Stage;
            this.defaults.isExternalUser = defaultsData.IsExternalUser;
            this.defaults.isDevUserManagementPortalUser = defaultsData.IsDevUserManagementPortalUser;
            this.defaults.isProdUserManagementPortalUser = defaultsData.IsProdUserManagementPortalUser;

            this.defaults.isDevMersyUMPUser = defaultsData.IsDevMersyUMPUser;
            this.defaults.isProdMersyUMPUser = defaultsData.IsProdMersyUMPUser;
            this.defaults.isDevADOGroupUMPUser = defaultsData.IsDevADOGroupUMPUser;
            this.defaults.isProdADOGroupUMPUser = defaultsData.IsProdADOGroupUMPUser;

            this.defaults.isPBIWorkspaceCreatorUser = defaultsData.IsPBIWorkspaceCreatorUser;

            this.defaults.IsLicenseManagerUser = defaultsData.IsLicenseManagerUser;
            this.defaults.isEMTManagerUser = defaultsData.IsEMTManagerUser;
            this.defaults.isEMTFactorySupportEngineer = defaultsData.IsEMTFactorySupportEngineer;
            this.defaults.isEMTFieldSupportEngineer = defaultsData.IsEMTFieldSupportEngineer;
            this.defaults.isMfgManagerUser = defaultsData.IsMfgManagerUser;
            this.defaults.isUMPDataAnalyticsUser = defaultsData.IsUMPDataAnalyticsUser;
            this.defaults.isHomManagerUser = defaultsData.IsHomManagerUser;
            this.defaults.isGlobalSystemAdmin = defaultsData.IsGlobalSystemAdmin;
            this.defaults.isGlobalLocalUserMgmt = defaultsData.IsGlobalLocalUserMgmt;
            this.defaults.isUserMgmtFldBranchesUser = defaultsData.IsUserMgmtFldBranchesUser;

            this.defaults.isMFGAdminUser = defaultsData.IsMFGAdminUser;
            this.defaults.isMFGEquipmentManagerUser = defaultsData.IsMFGEquipmentManagerUser;
            this.defaults.isMFGAdminPDCSUser = defaultsData.IsMFGAdminPDCSUser;
            this.defaults.isMFGAdminCenterUser = defaultsData.IsMFGAdminCenterUser;
            this.defaults.isMFGContractEngineerUser = defaultsData.IsMFGContractEngineerUser;
            this.defaults.isDESConfAdmUser = defaultsData.IsDESConfAdmUser;

            this.defaults.isMersyAdminUser = defaultsData.IsMersyAdminUser;
            this.defaults.isMersyAdminBranchExcellenceUser = defaultsData.IsMersyAdminBranchExcellenceUser;
            this.defaults.isMgmtHierarchyAdmin = defaultsData.IsMgmtHierarchyAdmin;
            this.defaults.isMersyCDPTaxAdmin = defaultsData.IsMersyCDPTaxAdmin;
            this.defaults.isMersyNiOpsAdminUser = defaultsData.IsMersyNiOpsAdminUser;
            this.defaults.isMersyAdminMarketQueryUser = defaultsData.IsMersyAdminMarketQueryUser;
            this.defaults.isMersyAdminSafetySystemExcellence = defaultsData.IsMersyAdminSafetySystemExcellence;
            this.defaults.isMersyAdminINCO = defaultsData.IsMersyAdminINCO;
            this.defaults.isMaxRulebookGTL = defaultsData.IsMaxRulebookGTL;
            this.defaults.isMaxRulebookSupervisorAppUser = defaultsData.IsMaxRulebookSupervisorAppUser;
            this.defaults.isTenantRemoteActionAdminUser = defaultsData.IsTenantRemoteActionAdminUser;
            this.defaults.isControllerRemoteActionAdminUser = defaultsData.IsControllerRemoteActionAdminUser;
        }
        else {
            this.defaults.managementids = defaultsData.ManagementIds;
            this.defaults.managementid = defaultsData.Session.ManagementId.toString();
            this.defaults.quarterId = defaultsData.Session.QuarterId;

            this.defaults.fiscalYear = defaultsData.Session.FiscalYear
            this.defaults.period = defaultsData.Session.Period
            this.defaults.language = defaultsData.SelectedLanguage;
            this.defaults.languages = defaultsData.Languages;
            this.defaults.groupFunctions = defaultsData.GroupFunctions
            this.defaults.hasProductTypeRoles = defaultsData.HasProductTypeRoles;
            this.defaults.hasLineOfBusinessRoles = defaultsData.HasLineOfBusinessRoles;
            this.defaults.mersyGroupFunctions = defaultsData.MersyGroupFunctions
            this.defaults.groupFunction = defaultsData.Session.GroupFunction
            this.defaults.IsMersyUser = defaultsData.IsMersyUser;
            this.defaults.isMersyAdminUser = defaultsData.IsMersyAdminUser;
            this.defaults.isMersyAdminBranchExcellenceUser = defaultsData.IsMersyAdminBranchExcellenceUser;
            this.defaults.isMgmtHierarchyAdmin = defaultsData.IsMgmtHierarchyAdmin;
            this.defaults.isMersyCDPTaxAdmin = defaultsData.IsMersyCDPTaxAdmin;
            this.defaults.isMersyCDPTaxRevoker = defaultsData.IsMersyCDPTaxRevoker;
            this.defaults.isMersyCDPTaxReporter = defaultsData.IsMersyCDPTaxReporter;
            this.defaults.isMersyCDPTaxViewer = defaultsData.IsMersyCDPTaxViewer;
            this.defaults.isMersyBranchManagerBranchExcellenceUser = defaultsData.IsMersyBranchManagerBranchExcellenceUser;
            this.defaults.isMersyCoachBranchExcellenceUser = defaultsData.IsMersyCoachBranchExcellenceUser;
            this.defaults.isMersyViewerBranchExcellenceUser = defaultsData.IsMersyViewerBranchExcellenceUser;
            this.defaults.isMersyAdminMarketQueryUser = defaultsData.IsMersyAdminMarketQueryUser;
            this.defaults.isMersyOwnerMarketQueryUser = defaultsData.IsMersyOwnerMarketQueryUser;
            this.defaults.isMersyRevokerMarketQueryUser = defaultsData.IsMersyRevokerMarketQueryUser;
            this.defaults.isMersyReporterMarketQueryUser = defaultsData.IsMersyReporterMarketQueryUser;
            this.defaults.isMersyDelegateMarketQueryUser = defaultsData.IsMersyDelegateMarketQueryUser;
            this.defaults.isMersyViewerMarketQueryUser = defaultsData.IsMersyViewerMarketQueryUser;
            this.defaults.isMersyDelegatedUser = defaultsData.IsMersyDelegatedUser;
            this.defaults.isMersyOwnerUser = defaultsData.IsMersyOwnerUser;
            this.defaults.isMersyReporterUser = defaultsData.IsMersyReporterUser;
            this.defaults.isMersyViewerUser = defaultsData.IsMersyViewerUser;

            this.defaults.isMersyDelegatedBranchReportingUser = defaultsData.IsMersyDelegatedBranchReportingUser;
            this.defaults.isMersyReporterBranchReportingUser = defaultsData.IsMersyReporterBranchReportingUser;
            this.defaults.isMersyViewerBranchReportingUser = defaultsData.IsMersyViewerBranchReportingUser;
            this.defaults.isMersyRevokerUser = defaultsData.IsMersyRevokerUser;
            this.defaults.isMersyRevokerBranchReportingUser = defaultsData.IsMersyRevokerBranchReportingUser;

            this.defaults.isMersyNiOpsAdminUser = defaultsData.IsMersyNiOpsAdminUser;
            this.defaults.isMersyNiOpsReporterUser = defaultsData.IsMersyNiOpsReporterUser;

            this.defaults.isMersyAdminSafetySystemExcellence = defaultsData.IsMersyAdminSafetySystemExcellence;
            this.defaults.isMersyAssessorSafetySystemExcellence = defaultsData.IsMersyAssessorSafetySystemExcellence;
            this.defaults.isMersyReporterSafetySystemExcellence = defaultsData.IsMersyReporterSafetySystemExcellence;

            this.defaults.isMersyAdminINCO = defaultsData.IsMersyAdminINCO;
            this.defaults.isMersyUserINCO = defaultsData.IsMersyUserINCO;
        }

        this.defaults.isadminuser = defaultsData.IsAdminUser;
        this.defaults.session = defaultsData.Session;
        this.defaults.branches = defaultsData.Branches;

        this.defaults.notifyStageChange(this.defaults.stage.toString())
        this.defaults.notifyLanguageChange(this.defaults.language)
        this.defaults.notifyManagementIdChange()
        this.defaults.notifyFiscalYearChange()
        this.defaults.loadInitialData = true;
        this.reload = Math.random() * 100
    }


    checkAndSetActiveAccount() {
        /**
         * If no active account set but there are accounts signed in, sets first account to active account
         * To use active account set here, subscribe to inProgress$ first in your component
         * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
         */
        let activeAccount = this.authService.instance.getActiveAccount();

        if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
            let accounts = this.authService.instance.getAllAccounts();
            // add your code for handling multiple accounts here
            this.authService.instance.setActiveAccount(accounts[0]);
        }
    }

    async login() {

        if (this.msalGuardConfig.authRequest) {
            await this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
        } else {
            await this.authService.loginRedirect();
        }

    }

    private setStageFromEnv(): void {
        const detectedStage = environment.stage;
        if (this.defaults.stage !== detectedStage) {
            this.defaults.stage = detectedStage;
            const url = this.baseUrl + Utils.getGenericAPI() + detectedStage;
            this.http.put<boolean>(url, detectedStage).subscribe(() => {
                this.defaults.stageAfterRedirect = detectedStage;
                this.defaults.notifyStageChange(detectedStage.toString());
            });
        }
    }

    // unsubscribe to events when component is destroyed
    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }

    onTenantSelectedChanged(evt: any) {
        this.onTenantChanged.emit(evt);
        if (this.onTenantChanged.observers.length === 0)
            this.waiting.toWait(false);
    }
    onInlineDocClick() {
        //this.wikiChangeService.getIsWikiAvailable()
        this.isWikiBtnDisabled ? null : this.hideInlineDoc = !this.hideInlineDoc;
    }
    receiveWikiAvBool(value: boolean) {
        this.isWikiBtnDisabled = value;
    }
    onControllerTypeSelectedChanged(evt: any) {
        this.onControllerTypeChanged.emit(evt);
        if (this.onControllerTypeChanged.observers.length === 0)
            this.waiting.toWait(false);
    }
    onLanguageSelectedChanged(evt: any) {
        this.onLanguageChanged.emit(evt);
        if (this.onLanguageChanged.observers.length === 0)
            this.waiting.toWait(false);
    }

    onStageSelectedChanged(evt: any) {
        this.onStageChanged.emit(evt);
        if (this.onStageChanged.observers.length === 0)
            this.waiting.toWait(false);
    }
    onManagementIdSelectedChanged(evt: any) {
        this.onManagementIdChanged.emit(evt);
        if (this.onManagementIdChanged.observers.length === 0)
            this.waiting.toWait(false);
    }

    receiveWikiLdBarBool(value: boolean) {
        this.showWikiLoadBar = value;
    }
}
